import { getWeekdayDayAndMonth } from '@/shared/lib/time-utils';

// e.g. "Thursday, May 5" — no year.
export function formatScheduleSessionDateTrigger(date: Date): string {
    const { weekday, dayAndMonth } = getWeekdayDayAndMonth(date);
    return `${weekday}, ${dayAndMonth}`;
}
